import { quitFromLink } from '../helpers/quitNodeHelper'
import { insertLink } from '../helpers/slateHelper'
import { isUrl } from '../helpers/urlHelper'
import { BLOCK_FORMATS, CustomEditor } from '../interface/custom-types'

export const withInlines = (editor: CustomEditor) => {
  const { insertData, insertText, isInline } = editor

  editor.isInline = (element) =>
    (BLOCK_FORMATS.link === element.type && element['view'] !== 'image') || isInline(element)

  editor.insertText = (text) => {
    if (text && isUrl(text)) {
      insertLink(editor, { text: text, url: text }, 'text')
    } else {
      insertText(text)
    }
  }

  editor.insertData = (data) => {
    const text = data.getData('text/plain')
    if (text && isUrl(text)) {
      insertLink(editor, { text: text, url: text }, 'text')
      if (editor.selection) {
        quitFromLink(editor, editor.selection)
      }
    } else {
      insertData(data)
    }
  }

  return editor
}
